// `release-semver.sh` appends `-wip` to the version string when the build
// happens with a dirty working tree. The same commit + tag with and without
// that suffix should not be treated as a new release for the user.
export function stripWipSuffix(value) {
    return String(value ?? '').replace(/-wip$/, '');
}

export function isWipOnlyMismatch(current, latest) {
    if (!current?.release || !latest?.release) {
        return false;
    }
    if (current.release === latest.release) {
        return false;
    }
    if (String(current.release_timestamp) !== String(latest.release_timestamp)) {
        return false;
    }
    // Belt-and-braces: the release string already embeds the tag + commit,
    // but compare them explicitly so a future change to the release format
    // can't silently widen what we suppress.
    if (String(current.release_tag ?? '') !== String(latest.release_tag ?? '')) {
        return false;
    }
    if (String(current.release_commit ?? '') !== String(latest.release_commit ?? '')) {
        return false;
    }
    return stripWipSuffix(current.release) === stripWipSuffix(latest.release);
}

export default {
    stripWipSuffix,
    isWipOnlyMismatch,
};
